import { createSlice } from '@reduxjs/toolkit'

const initialState = {
	terminology: {},
	purchasedTickets: [],
	metaData: {},
}

const ticketsSlice = createSlice({
	name: 'tickets',
	initialState,
	reducers: {
		updateGlobalTicketsState(state, { payload }) {
			return { ...state, ...(payload || {}) }
		},
		setPurchasedTickets(state, { payload }) {
			return { ...state, purchasedTickets: [...(payload || [])] }
		},
	},
})

export const { updateGlobalTicketsState, setPurchasedTickets } = ticketsSlice.actions

export default ticketsSlice.reducer
